import { connect } from "react-redux";
import { Link } from "react-router-dom";

import HotelNoImage from "../../image/default-hotel-image.svg";
import Rating from "../Common/Rating";
import Price from "../Common/Price";
import LayoutConfig from "../../Config/layoutConfig";

const DomesticHotelItem = props => {

    const { hotel, Dictionary } = props;

    const isStyle3 = LayoutConfig.themeClassName === 'style-3';

    let price;
    switch (hotel.priceInformation) {
        case "pending":
            price = <div className="line-height-44"><span className="loading-inline-circle" /></div>;
            break;
        case "not-priced":
            price = null;
            break;
        case "need-to-inquire":
            price = <p className={`margin-bottom-light purple`}>
                قیمت نیازمند استعلام است
            </p>
            break;
        default:
            price = (
                <>
                    <div className="text-end prices-holder line-height-22">
                        {hotel.priceInformation?.discountPercent === 0 ? (
                            <b
                                className="small-margin-bottom text-center"
                                dir="ltr"
                            >
                                <Price currency={props.currencyCode}>
                                    {hotel.priceInformation?.salePrice}
                                </Price>
                            </b>
                        ) : (
                            <>
                                <div className="hotel-old-price no-wrap">
                                    <Price currency={props.currencyCode}>
                                        {hotel.priceInformation?.boardPrice}
                                    </Price>
                                </div>
                                <b className="small-margin-bottom text-center no-wrap">
                                    <Price currency={props.currencyCode}>
                                        {hotel.priceInformation?.salePrice}
                                    </Price>
                                </b>
                            </>
                        )}
                    </div>
                    <div className="text-end font-12 gray price-for-night line-height-22">
                        <span>{Dictionary.startingPrice}</span> <span className="nowrap"> ({props.dateInfo?.duration} {Dictionary.nights}) </span>
                    </div>
                </>
            )
    }

    return (
        <div className={`margin-bottom bg-white domestic-hotel-item ${isStyle3?"box-border ir-style":"box-shadow"}`}>
            <div
                className={`hotel-image ${hotel.picture?.path ? "" : "default-image"}`}
                style={{ backgroundImage: `url("${hotel.picture?.path || HotelNoImage}")` }}
            />
            <div className="content">
                <main className="content-main">
                    <b className="margin-end-half">{hotel.displayName || hotel.name}</b>
                    <Rating number={hotel.rating} className="inline-block-middle margin-end-half" />
                    <span className="gray-tag font-13">{hotel.typeStr}</span>

                    {hotel.address && <p className="gray font-13 margin-bottom-light">{hotel.address}</p>}

                    {!price && <div className={`padding-v-10 padding-h-15 margin-top-half ${isStyle3?"bg-light-purple":"bg-light-pink"}`}>
                        <strong className="margin-bottom-light semi-bold purple">
                            <span className="itours-icon red-clock-icon icon-small margin-end-light" />
                            این مورد را از دست دادید!
                        </strong>
                        <div className="font-13">برای این تاریخ ها هیچ اتاقی در دسترس نداریم</div>
                    </div>}
                </main>
                {!!price && <footer className="content-footer text-end">

                    <div>
                        {price}
                        {!!price && <Link
                            className={`button full-width has-arrow nowrap margin-top-light ${isStyle3?"purple-btn":"red-btn"}`}
                            target="_blank"
                            to={`/domesticHotel/details?id=${hotel?.id}&checkin=${props.dateInfo?.checkIn}&checkout=${props.dateInfo?.checkOut}`}
                        >
                            {Dictionary.seeRooms}
                        </Link>}
                    </div>

                </footer>}
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        Dictionary: state.VisualData.Dictionary,
        LAN: state.VisualData.LAN,
        currencyCode: state.UserData.Currency
    };
};

export default connect(mapStateToProps)(DomesticHotelItem);